/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_Dim_Trust_EeatInputs */

const en_directory_detail_signals_geo_dim_trust_eeat = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_Trust_EeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trust & E-E-A-T`)
};

const zh_directory_detail_signals_geo_dim_trust_eeat = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_Trust_EeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信任与 E-E-A-T`)
};

/**
* | output |
* | --- |
* | "Trust & E-E-A-T" |
*
* @param {Directory_Detail_Signals_Geo_Dim_Trust_EeatInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_dim_trust_eeat = /** @type {((inputs?: Directory_Detail_Signals_Geo_Dim_Trust_EeatInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_Dim_Trust_EeatInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_dim_trust_eeat(inputs)
	return zh_directory_detail_signals_geo_dim_trust_eeat(inputs)
});
export { directory_detail_signals_geo_dim_trust_eeat as "directory.detail.signals.geo_dim.trust_eeat" }